import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GetDadosService {

  constructor(
    private http: HttpClient
  ) { }

  getBrowserDetail(parameters?: any) {
    let link = `${environment.protheus}/dados?${parameters}`;
    return this.http.get(link);
  }
}
